import { render, staticRenderFns } from "./GestationalAge.vue?vue&type=template&id=cf90a06c&scoped=true&"
import script from "./GestationalAge.vue?vue&type=script&lang=js&"
export * from "./GestationalAge.vue?vue&type=script&lang=js&"
import style0 from "./GestationalAge.vue?vue&type=style&index=0&media=print&lang=css&"
import style1 from "./GestationalAge.vue?vue&type=style&index=1&id=cf90a06c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf90a06c",
  null
  
)

export default component.exports